import { errorHandler } from 'utils/errorMessages';
import { showSnackbar, setLoading, toggleModal } from 'reducers/ui';
import { takeLatest, put, call, select } from 'redux-saga/effects';
import { get, isEmpty } from 'lodash';
import { getSecurityId } from 'reducers/users';
import API from 'services/api';
import { actions as assetTypeActions } from 'containers/Pages/Assets/AssetTypes/Modules/dataGridTable';
import { actions as assetFilterTypeActions } from 'containers/Pages/Assets/AssetTypes/Modules/filters';
import { nameSpace } from 'containers/Pages/Assets/AssetTypes/Modules/nameSpace';
import * as assetTypeSelectors from 'containers/Pages/Assets/AssetTypes/Selectors/assetTypeSelectors';
import * as pageActions from 'containers/Pages/Assets/AssetTypes/Actions/assetTypePageActions';
import { actions as embeddedFormActions } from 'modules/embeddedForms/reducer';

export function* fetchAssetTypeListSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { filters, from } = payload;
    const filterKeyStatus = yield select(
      assetTypeSelectors.getAssetTypeFilterKey,
    );
    const forceRefresh = yield select(assetTypeSelectors.getForceRefresh);
    const securityCompanyId = yield select(getSecurityId);
    const options = {
      securityCompanyId,
      ...filters,
      from,
      archived: get(filters, 'archived', false),
    };
    const getAssetTypeList = yield select(
      assetTypeSelectors.getAssetTypeListRaw,
    );
    if (isEmpty(getAssetTypeList) || forceRefresh || filterKeyStatus) {
      const { data } = yield call(API.getAssetTypeList, options);
      if (data.data) {
        const totalEntries = get(data, 'meta.total');
        yield put(
          assetTypeActions.setGridList({
            list: data.data,
            totalEntries,
          }),
        );
      }
    }

    if (filterKeyStatus) {
      yield put(assetFilterTypeActions.setFilterKey(false));
    }
    if (forceRefresh) {
      yield put(assetTypeActions.setForceRefresh(false));
    }
    yield put(setLoading(false));
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}

export function* fetchAssetTypeDetailsSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { id } = payload;
    //select from the state
    const rows = yield select(assetTypeSelectors.getAssetTypeListRaw);
    const value = rows.find(f => f.id === id);
    if (value) {
      yield put(assetTypeActions.setGridRowDetails({ details: value }));
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* createAssetTypeSaga({ payload }) {
  try {
    const { assetType, embeddedForm } = payload;
    yield put(setLoading(true));
    const { status, data } = yield call(API.createAssetType, { ...assetType });
    if (status === 200 && embeddedForm) {
      yield put(
        embeddedFormActions.setEmbeddedFormDetails({
          formType: nameSpace,
          details: data.data,
        }),
      );
      // pass this info into the embedded form state
    }
    // only flip the modal if the form is opened in the actual business client component
    if (!embeddedForm) {
      yield put(toggleModal(nameSpace));
    }

    yield put(setLoading(false));
  } catch (err) {
    yield put(setLoading(false));
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
}
export function* refreshAssetTypeDetails() {
  try {
    yield put(setLoading(true));
    const id = yield select(assetTypeSelectors.getSelectedRowID);
    yield call(fetchAssetTypeDetailsSaga, { payload: { id } });
  } catch (err) {
    showSnackbar({
      typeOfSnackbar: 'error',
      message: errorHandler(err),
    });
  }
  yield put(setLoading(false));
}

export function* updateAssetTypeSaga({ payload }) {
  const { assetType } = payload;
  const { id } = assetType;
  try {
    yield put(setLoading(true));
    const { status } = yield call(API.updateAssetType, id, assetType);

    if (status === 200) {
      yield put(toggleModal(nameSpace));
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}

export function* assetTypeSagas() {
  yield takeLatest(assetTypeActions.fetchGridList, fetchAssetTypeListSaga);
  yield takeLatest(
    assetTypeActions.fetchGridRowDetails,
    fetchAssetTypeDetailsSaga,
  );
  yield takeLatest(assetTypeActions.createRowEntry, createAssetTypeSaga);
  yield takeLatest(assetTypeActions.updateRowEntry, updateAssetTypeSaga);
  yield takeLatest(
    pageActions.refreshAssetTypeDetails,
    refreshAssetTypeDetails,
  );
}
